export default __webpack_public_path__ + "static/Technology-88a235cad85d6a3cd697a57815f6c03a.png";